import { useState, useEffect } from "react";
import { getBackendBaseUrl } from "../utils/backendUrl";

const Profilecard = ({ data }) => {
  const [showMore, setShowMore] = useState(false);
  const [speaking, setSpeaking] = useState(false);
  const [muted, setMuted] = useState(false);

  const article = Array.isArray(data) ? data[0] : data;

  // ✅ Hook must be before any return
  useEffect(() => {
    if (article) {
      console.log("PROFILE ARTICLE:", article);
    }
  }, [article]);

  if (!article) return null;

  const handleListen = (text) => {
    if (!text) return;

    if (speaking) {
      window.speechSynthesis.cancel();
      setSpeaking(false);
      setMuted(true);
      return;
    }

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "hi-IN";
    utterance.rate = 0.9;

    utterance.onend = () => {
      setSpeaking(false);
      setMuted(false);
    };

    window.speechSynthesis.speak(utterance);
    setSpeaking(true);
    setMuted(false);
  };

  const rawDescription = article.description || "";
  const words = rawDescription.split(" ");

  const PREVIEW_WORDS = 50;
  const previewText = words.slice(0, PREVIEW_WORDS).join(" ");
  const remainingText = words.slice(PREVIEW_WORDS).join(" ");

  return (
    <article className="bg-white p-6 rounded-lg shadow-md relative">

      {/* CATEGORY & SHARE */}
      <div className="flex items-center justify-between mb-3">
        {(article.state || article.category) && (
          <span className="inline-block bg-red-100 text-red-600 text-xs font-semibold px-3 py-1 rounded">
            {article.state ? article.state : article.category}
          </span>
        )}

        <div className="flex gap-3">
          {article.youtube_url && (
            <a
              href={article.youtube_url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#FF0000] hover:opacity-80 transition"
            >
              <i className="fab fa-youtube text-lg"></i>
            </a>
          )}
          <button
            onClick={async () => {
              const url = window.location.origin + "/news/" + article.id;
              if (navigator.share) {
                try {
                  await navigator.share({
                    title: article.news_title,
                    url: url,
                  });
                } catch (err) {
                  console.error(err);
                }
              } else {
                navigator.clipboard.writeText(url);
                alert("Link copied to clipboard!");
              }
            }}
            className="text-gray-600 hover:text-red-600 transition"
            title="Share"
          >
            <i className="fa-solid fa-share-nodes text-lg"></i>
          </button>
        </div>
      </div>

      {/* TITLE */}
      <h1 className="text-[32px] leading-tight font-extrabold text-gray-900 mb-3">
        {article.news_title}
      </h1>

      {/* REPORTER SECTION */}
      {(article.reporter_name || article.reporter_image) && (
        <div className="flex items-center gap-3 mb-4 text-sm text-gray-600">
          {article.reporter_image && (
            <img
              src={`${getBackendBaseUrl()}/uploads/news/${article.reporter_image}`}
              alt={article.reporter_name}
              className="w-8 h-8 rounded-full object-cover"
            />
          )}
          <span className="font-semibold">
            {article.reporter_name}
          </span>
        </div>
      )}

      {/* IMAGE */}
      {article.thumbnail && (
        <div className="mb-6">
          <img
            src={`${getBackendBaseUrl()}/uploads/news/${article.thumbnail}`}
            alt={article.news_title}
            className="w-full rounded-lg"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/no-image.png";
            }}
          />

          <div className="flex items-center gap-4 mt-3">
            {article.youtube_url && (
              <a
                href={article.youtube_url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm font-semibold text-white bg-red-600 px-3 py-1.5 rounded-full shadow-sm hover:bg-red-700 transition"
              >
                <i className="fab fa-youtube text-lg"></i>
                <span>YouTube</span>
              </a>
            )}

            <button
              onClick={() => handleListen(rawDescription)}
              className="flex items-center gap-2 text-sm font-semibold text-white bg-red-600 px-3 py-1.5 rounded-full shadow-sm hover:bg-red-700 transition"
            >
              <i className="fa-solid fa-volume-high text-lg"></i>
              <span>सुनें</span>
            </button>
          </div>
        </div>
      )}

      {/* DESCRIPTION */}
      {!showMore && previewText && (
        <p className="text-gray-700 text-[17px] mb-4 leading-relaxed">
          {previewText}
          {remainingText && <span>...</span>}
        </p>
      )}

      {/* FULL TEXT */}
      {showMore && (
        <p className="text-gray-700 text-[17px] leading-relaxed mb-4">
          {rawDescription}
        </p>
      )}

      {/* READ MORE */}
      {remainingText && (
        <div className="mt-6 flex flex-col items-center gap-2">
          {!showMore && (
            <span className="text-xs uppercase tracking-widest text-gray-500">
              
            </span>
          )}
          <button
            onClick={() => setShowMore(!showMore)}
            className="px-6 py-2 border rounded-full text-sm font-semibold hover:bg-gray-100 transition flex items-center gap-2"
          >
            {showMore ? "Close" : "आगे पढ़ें"}
            {!showMore && <i className="fa-solid fa-arrow-right"></i>}
          </button>
        </div>
      )}
    </article>
  );
};

export default Profilecard;
